import * as actionTypes from "../mutation-types";

// initial state
const state = {
	content: ""
};

// getters
const getters = {
	termsAndConditionsContent: state => state.content
};

// actions
const actions = {
	[actionTypes.SET_TERMS_AND_CONDITIONS]: ({ commit }, data) => {
		return commit(actionTypes.SET_TERMS_AND_CONDITIONS, data);
	}
};

// mutations
const mutations = {
	[actionTypes.SET_TERMS_AND_CONDITIONS] (state, payload) {
		state.content = payload;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
